import styled, { css } from "styled-components";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";

// eslint-disable-next-line import/prefer-default-export
export var Container = styled(FlexContainerOrg).withConfig({
  componentId: "sc-rzyuws-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["position:relative;background-color:", ";padding:", " ", ";border-radius:", ";box-shadow:", ";cursor:pointer;&:hover{box-shadow:", ";}"], getColor(theme, "backgroundLight"), space(2), space(3), getBorderRadius(theme, "mlarge"), getBoxShadow(theme, "nano"), getBoxShadow(theme, "tiny"));
});